export const URL = {
  login: "~/admin/login",
  logout: "~/admin/logout",
  adminProfile: "~/admin/details",
  adminEditProfile: "~/admin/edit-profile",
  forgotPassword: "~/admin/forgot-password",
  resetPassword: "~/admin/reset-password",
  changePassword: "~/admin/change-password",
  usersList: "~/admin/user-list",
  usersDetails: "~/admin/userDetails",
  usersBlockUnblock: "~/admin/block-unblock-user",
  createPowerUser: "~/admin/create-super-user",
  updateSuperUserStatus: "~/admin/update-super-user",
  updateUserCategory: "~/admin/update-user-category",
  getQuizQuestions: "https://avtopia-backend.previewbay.com/avtopia/api/v1/user/quiz-question",
  aircrafts: "~/admin/aircraftListing",

  /**
   * ! aircraft problem urls
   */
  aircraftProblem: "~/admin/aircraft-problem",
  aircraftProblemStatus: "~/admin/aircraft-problem-status",

  /**
   * ! aircraft categories urls
   */
  aircraftCategories: "~/admin/aircraft-category",
  aircraftCategoriesStatus: "~/admin/aircraft-category-status",
  aircraftCategoriesDetails: (id: any) =>
    `~/admin/aircraft-category-details/${id}`,
  /**
   * ! repairt types urls
   */
  repairTypes: "~/admin/aircraft-repair-type",
  repairTypeStatus: "~/admin/aircraft-repair-type-status",
  /**
   * !bussiness profile route
   */
  bussinessProfile: "~/admin/business-profile",
  bussinessProfileStatus: "~/admin/business-profile-status",
  bussinessProfileDetails: (id: any) =>
    `~/admin/business-profile-details/${id}`,
  /**
   * ! aircraft make  urls
   */

  aircraftMake: "~/admin/aircraft-make",
  aircraftMakeDetails: (id: string) => `~/admin/aircraft-make-details/${id}`,
  aircraftMakeStatus: "~/admin/aircraft-make-status",

  /**
   * ! aircraft model urls
   */

  aircraftModel: "~/admin/aircraft-model",
  aircraftModelDetails: (id: string) => `~/admin/aircraft-model/${id}`,
  aircraftModelStatus: "~/admin/aircraft-model-status",

  /**
   * ! topic category urls
   */
  topicCategory: "~/admin/topic-category",
  topicCategoryStatus: "~/admin/topic-category-status",
  topicCategoryDetails: (id: string) => `~/admin/topic-category-detail/${id}`,

  /**
   * ! business category urls
   */
  businessCategory: "~/admin/business-category",
  businessCategoryStatus: "~/admin/business-category-status",
  businessCategoryDetails: (id: string) =>
    `/admin/business-category-details/${id}`,
  businessCategoryList: "~/admin/business-category-list",

  /**
   * ! icon category urls
   */
  iconCategory: "~/admin/icon-category",
  iconCategoryStatus: "~/admin/icon-category-status",
  iconCategoryDetails: (id: string) => `~/admin/icon-category-details/${id}`,

  /**
   * !event category urls
   */
  eventCategory: "~/admin/event-category",
  eventCategoryStatus: "~/admin/event-category-status",

  /**
   * ! report post-question  urls
   */
  adminReportStatus: "~/admin/reportMark-asRead",
  reportPost: "~/admin/reportPost-listing",
  reportPostBlockUnblock: (postId, status) =>
    `~/admin/block-post/${postId}/${status}`,
  reportPostComment: "~/admin/allReportPost-comment",
  reportPostCommentBlockUnblock: (commentId, status) =>
    `~/admin/block-postComment/${commentId}/${status}`,
  reportPostReply: "~/admin/allReportcomment-reply",
  reportPostReplyBlockUnblock: (replyId, commentId, status) =>
    `~/admin/block-commentReply/${replyId}/${commentId}/${status}`,

  /**
   * ! policy management listing  urls
   */
  policyManagementListing: "~/content",
  contentDetails: `~/content/details`,
  contentUpdate: (id: string) => `~/content/${id}`,

  /**
   * !squawkpit module urls
   */
  squawkpitTopicQuestionListing: "~/admin/question-listing",
  squawkpitTopicQuestionDelete: "~/admin/question-delete",
  squawkpitTopicAnswerListing: "~/admin/answer-listing",
  squawkpitTopicAnswerDelete: "~/admin/answer-delete",
  squawkpitTopicAnswerReplyDelete: "~/admin/answer-reply-delete",
  squawkpitTopicRepliesList: "~/admin/topic-reply",
  reportQuestion: "~/admin/report-topicListing",
  reportQuestionBlockUnblock: (questionId, status) =>
    `~/admin/block-topic/${questionId}/${status}`,
  reportQuestionAnswer: "~/admin/allReportTopic-answer",
  reportQuestionAnswerBlockUnblock: (answerId, status) =>
    `~/admin/block-topic-answer/${answerId}/${status}`,
  reportQuestionReply: "~/admin/allReportAnswer-reply",
  reportQuestionReplyBlockUnblock: (replyId, answerId, status) =>
    `~/admin/block-answer-reply/${replyId}/${answerId}/${status}`,

  /**
   * !events module urls
   */
  eventsListing: "~/admin/eventListing",
  eventsDetails: "~/admin/eventDetails",
  eventsDelete: "~/admin/eventDelete",

  /**
   * !posts module urls
   */
  postsListing: "~/admin/postListing",
  postsDetails: "~/admin/postDetails",
  postsDelete: "~/admin/postDelete",
  commentDelete: "~/admin/commentPostDelete",
  replyDelete: "~/admin/commentReplyDelete",
  postCommentListing: "~/admin/post-commentListing",
  postReplyListing: "~/admin/comment-replyListing",

  /**
   * !businesses module urls
   */
  businessListing: "~/admin/business-Listing",
  businessDetails: "~/admin/businessDetails",
  businessDelete: "~/admin/businessDelete",
  businessRatingListing: "~/admin/businessReviewListing",
  businessRatingDelete: "~/admin/businessReviewDelete",
  blockUnblockBusiness: "~/admin/block-unblock-business",

  /**
   * @description
   * admin business type
   */
  businessType: "~/admin/business-type",
  businessTypeStatus: "~/admin/business-type-status",
  businessTypeDetails: (id: string) => `~/admin/business-type-details/${id}`,
  /**
   * !advertisement module urls
   */
  advertisementAddEditDelete: "~/admin/advertiseForm",
  advertisementDetails: "~/admin/advertiseDetails",
  advertisementList: "~/admin/allAdvertiseListing",

  /**
   * !banner management (mobile app banners)
   */
  bannerList: "~/admin/banner",
  bannerDetails: (id: string) => `~/admin/banner/${id}`,
  bannerCreate: "~/admin/banner",
  bannerUpdate: (id: string) => `~/admin/banner/${id}`,
  bannerDelete: (id: string) => `~/admin/banner/${id}`,
  activeBanners: "~/banners", // Mobile app endpoint - get active banners

  /**
   * !notification module urls
   */
  notificationApi: "~/admin-notification",
  resendNotification: "~/admin-notification/resend",
  notificationGroupApi: "~/admin-notification-group",

  /**
   * !Quiz module urls
   */
  // quizApi: '~/admin/quiz',
  quizeDetails: "~/admin/quiz-details",
  // quizeStatus: '~/admin/quiz-status',
  quizUpdate: "~/admin/quiz-update",

  // new quiz apis
  deleteAnswer: "~/admin/question-answer-delete",
  quizApi: "~/admin/question-answer",
  quizById: (id: string) => `~/admin/question-details/${id}`,
  quizeStatus: "~/admin/question-status",
  // level one
  levelOneApi: "~/admin/answer-lavel-one",
  levelOneById: (id: string) => `~/admin/answer-lavel-one/${id}`,

  // Level Two
  levelTwoApi: "~/admin/answer-lavel-two",

  // Level Three
  levelThreeApi: "~/admin/answer-lavel-three",

  // level Four
  levelFourApi: "~/admin/answer-lavel-four",

  // level Five
  levelFiveApi: "~/admin/answer-lavel-five",

  /**
   * service station urls
   */
  serviceStations: "~/admin/service-station-listing",
  serviceStationStatus: "~/admin/block-unblock-station",
  /**
   * !version module urls
   */
  versionList: "~/version",
  versionAdd: "~/version",
  versionUpdate: (versionId) => `~/version/${versionId}`,
  versionDelete: (versionId) => `~/version/${versionId}`,

  vendorDetailsList: `~/admin/vendor-aog-details`,
  /**
   * !dashBoard module urls
   */
  dashBoardCounts: "~/admin/countOn-dashboard",
  dashboardPlatformGraph: "~/admin/user-platform-graph",
  dashBoardUserGraph: "~/admin/user-registration-graph",
  dashBoardCountGraph: `~/admin/aogCount-graph`,
  /** User signups over time (keyArray/valueArray); query: type, year?, month? */
  dashBoardSignupsGraph: "~/admin/dashboard",

  /***
   * @description
   * import and exports xls constants
   */
  importAircraftMake: "~/admin/import-aircraft-make",
  importAircraftProblem: "~/admin/import-aircraft-problem",
  importBusinessCategory: "~/admin/import-business-category",
  importTopicCategory: "~/admin/import-topic-category",
  importAircraftCategory: "~/admin/import-aircraft-category",
  importEventCategory: "~/admin/import-event-category",
  importAvtopiaBusiness: "~/admin/import-avtopia-business",
  importMaintenanceType: "~/admin/import-maintenance-type",
  importIconCategory: "~/admin/import-icon-category",
  importBusinessType: "~/admin/import-business-type",
  // importAircraftCategory:'~/admin/import-aircraft-category',

  /**
   * @description
   * export xls URL constants
   */
  exportUserList: "~/admin/userList-report",
  exportBusinessList: "~/admin/businessList-report",
  exportFeedbackList: "~/admin/businessReviewList-report",
  exportPostsList: "~/admin/postList-report",
  exportAvtopiaBusiness: "~/admin/avtopia-business",
  exportAircraftList: "~/admin/aircraftListing-report",
  exportAircraftCategoryList: "~/admin/aircraftCategory-report",
  exportEventList: "~/admin/eventList-report",
  exportAdvertisementList: "~/admin/advertiseList-report",
  exportBusinessCategoryList: "~/admin/businessCategory-report",
  exportEventCategoryList: "~/admin/eventCategory-report",
  exportTopicCategoryList: "~/admin/topicCategory-report",
  exportMaintenanceTypeList: "~/admin/maintenance-type-report",
  exportIconCategoryList: "~/admin/icon-category-report",
  exportBusinessType: "~/admin/businessType-report",
  /**
   * @description
   * avtopia business constants
   *
   */
  avtopiaBusiness: "~/admin/avtopia-business",
  syncAvtopiaBusiness: "~/admin/avtopia-business-syncing",
  exportAvtopiaBusinessList: "~/admin/avtopia-business-report",

  /**
   * @description
   * aog request endpoints
   */
  aogRequest: "~/admin/aog",
  aogRequestDetails: (id: string) => `~/admin/aog-details/${id}`,

  /**
   * @description
   *
   */
  vendorProvider: "~/admin/aog-receiver-vendor",

  maintenanceType: "~/admin/maintenance-type",
  maintenanceTypeStatus: "~/admin/maintenance-type-status",
  maintenanceTypeDetails: (id: string) =>
    `~/admin/maintenance-type-details/${id}`,
  preregisterUsers: "~/admin/contact-us",
  /**
   * @description
   * admin referrals endpoints
   */
  adminGetAllReferrals: "~/admin/referrals",
  adminGetUserReferrals: (userId: string) => `~/admin/referrals/user/${userId}`,
  adminGetReferralById: (referralId: string) => `~/admin/referrals/${referralId}`,

  /**
   * @description
   * flight department endpoints
   */
  flightDepartment: "~/admin/flight-department",
  flightDepartmentStatus: "~/admin/flight-department/status",
  flightDepartmentDetails: (id: string) => `~/admin/flight-department/${id}`,

  registeredFlightDepartments: "~/admin/registered-flight-departments",
  registeredFlightDepartmentStatus: "~/admin/registered-flight-departments/status",
  registeredFlightDepartmentDetails: (id: string) => `~/admin/registered-flight-departments/${id}`,
};
